module.exports = "/assets/f58f96bb5a4a4b6e825ef5a6cdbc5d7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/LZ.png
// module id = 2721
// module chunks = 0